import * as yup from 'yup';

import contactSchema from './yup';

const featureLeadSchema = contactSchema.shape({
  feature: yup.string().required('*Required'),
  roles: yup.array().of(yup.string()).min(1, '*Required'),
});

export default featureLeadSchema;
